module.exports = __webpack_public_path__ + "img/seo.f7e68db3.gif";